import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import SocialConnect from "@/components/SocialConnect";

/**
 * Shared page chrome for non-landing routes. Mirrors the visual language of
 * the Legal pages (dark base, glass header, neon-green section eyebrow).
 *
 *   <PageShell eyebrow="// Company" title="About GigAfloat" testid="about-page">
 *     ...content...
 *   </PageShell>
 */
export const Section = ({ title, children }) => (
  <section className="mb-10">
    {title && (
      <h2 className="font-display text-xl sm:text-2xl font-extrabold tracking-tight mb-3">
        {title}
      </h2>
    )}
    <div className="text-white/65 leading-relaxed text-[15px] space-y-3">
      {children}
    </div>
  </section>
);

const PageShell = ({ eyebrow, title, subtitle, children, testid, max = "820px" }) => (
  <div className="min-h-screen bg-[#050505] text-white" data-testid={testid}>
    <header className="border-b border-white/5 sticky top-0 z-40 bg-[#050505]/70 backdrop-blur-xl">
      <div className="max-w-[900px] mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <ArrowLeft className="w-4 h-4 text-white/60" />
          <Logo />
        </Link>
      </div>
    </header>
    <main className="mx-auto px-6 lg:px-12 py-16" style={{ maxWidth: max }}>
      {eyebrow && (
        <div className="font-mono-c text-[10px] uppercase tracking-[0.25em] text-[#00FF88] mb-3">
          {eyebrow}
        </div>
      )}
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mb-2">
        {title}
      </h1>
      {subtitle && (
        <p className="text-white/55 text-base sm:text-lg mb-12 max-w-[640px] leading-relaxed">
          {subtitle}
        </p>
      )}
      {children}
      <SocialConnect variant="compact" />
      <div className="mt-16 pt-8 border-t border-white/5 text-sm text-white/45">
        Questions? Reach us at{" "}
        <a href="mailto:gigafloatapp@gmail.com" className="text-[#00FF88]">
          gigafloatapp@gmail.com
        </a>
        .
      </div>
    </main>
  </div>
);

export default PageShell;
